import { withDependencies } from '@wix/thunderbolt-ioc'
import { ILayoutDoneService, LayoutDoneServiceSymbol } from '@wix/thunderbolt-symbols'
import { IMenuContainerHooks } from '../types'

const menuContainerHooks = (layoutDoneService: ILayoutDoneService): IMenuContainerHooks => {
	return {
		onAnimationStart: () => {
			layoutDoneService.enableLayoutDone(false)
		},
		onAnimationEnd: () => {
			layoutDoneService.enableLayoutDone(true)
		},
	}
}

export const MenuContainerHooks = withDependencies([LayoutDoneServiceSymbol], menuContainerHooks)
